import React, {useEffect, useState} from 'react';

import PropTypes from "prop-types";

import {Dropdown} from "primereact/dropdown";


export function CustomerByGroupSelect(props) {
    const handleChange = (event) => {
        const myValue = props.customerList.find(x => x.id === event.target.value)
        props.setCustomer(myValue);


    };

    return (

            <Dropdown value={props.customer.id} onChange={handleChange} options={props.customerList}
                      optionLabel="name" optionValue="id" disabled={props.disable}
                      panelClassName=" flex-1 " tooltip="Select Customer" variant="filled" className="flex-1 md:w-4  w-full h-2rem align-items-center justify-content-center"
                      />

    )

}

CustomerByGroupSelect.propTypes = {
    customerList: PropTypes.array.isRequired,
    customer: PropTypes.object.isRequired,
    setCustomer: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,


}
